import "../css/DeleteModal.css";
import Modal from "./Modal";

const DeleteModal = ({ isOpen, onClose, onDelete }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="delete-modal-content">
        Do you want to delete this officer?
        <button className="delete-modal-delete-button" onClick={onDelete}>
          Delete
        </button>
      </div>
    </Modal>
  );
};
export default DeleteModal;
